import {
  OEText,
  flex,
  maxWidth,
  pr,
  width,
  minWidth,
} from '@openeducation/oe-it-components';
import type { LiveClassPendingFeedback } from '@openeducation/oe-it-shared-types';
import { styled } from '@openeducation/oe-it-themes';
import * as React from 'react';
import { View } from 'react-native';

export interface SelectedFeedbackHeaderProps {
  countryName?: string;
  selectedFeedback?: LiveClassPendingFeedback;
}

export const SelectedFeedbackHeader = ({
  countryName,
  selectedFeedback,
}: SelectedFeedbackHeaderProps) => {
  if (!selectedFeedback) return null;

  return (
    <View>
      <RowContainer>
        <View style={[flex('flex-2', 'flex-row')]}>
          <View>
            <ColumnLabel>NAME</ColumnLabel>
            <StudentName>{selectedFeedback.studentName}</StudentName>
          </View>
        </View>
        <View style={[flex('flex-row', 'flex-1', 'justify-content-between')]}>
          <View style={[minWidth(110), pr(24)]}>
            <ColumnLabel>STUDENT ID</ColumnLabel>
            <ColumnValue>{selectedFeedback.studentZoomId}</ColumnValue>
          </View>
          <View style={[maxWidth(38), width(38)]}>
            <ColumnLabel>LEVEL</ColumnLabel>
            <ColumnValue>{selectedFeedback.studentLevel}</ColumnValue>
          </View>
        </View>
      </RowContainer>
      <RowContainer>
        <View style={[flex('flex-1', 'flex-row', 'align-content-center')]}>
          <ColumnLabel>COUNTRY:</ColumnLabel>
          <ColumnCountry>{countryName}</ColumnCountry>
        </View>
      </RowContainer>
    </View>
  );
};

const RowContainer = styled.View`
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 10px;
`;

const ColumnValue = styled(OEText).attrs(({ theme, color }) => ({
  color: color ? color : theme.color.dark1,
  fontType: 'bold',
}))`
  overflow: hidden;
  font-size: 24px;
  height: 32px;
  line-height: 32px;
`;

const ColumnCountry = styled(ColumnValue)`
  font-size: 14px;
  height: 18px;
  line-height: 18px;
  margin-left: 5px;
`;

const ColumnLabel = styled(OEText).attrs(({ theme }) => ({
  color: theme.color.dark3,
  fontFamily: theme.font,
}))`
  font-size: 12px;
`;

const StudentName = styled(ColumnValue).attrs(({ theme }) => ({
  color: theme.color.primary,
}))`
  max-width: 280px;
`;
